
class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.widgetPackage = this.querySelectorAll('label.rm-card');

    this.initializeTabs();
  }

  initializeTabs() {
    this.widgetPackage.forEach((button) => {
      button.addEventListener('click', () => {
        this.widgetPackage.forEach((b) => b.classList.remove('rm-active'));
        button.classList.add('rm-active');
      });
    });
  }
}

customElements.define('subscription-widget', SubscriptionWidget);